import { render, staticRenderFns } from "./PuntosImpresion.vue?vue&type=template&id=34f7bdd3&scoped=true&"
import script from "./PuntosImpresion.vue?vue&type=script&lang=js&"
export * from "./PuntosImpresion.vue?vue&type=script&lang=js&"
import style0 from "./PuntosImpresion.vue?vue&type=style&index=0&id=34f7bdd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f7bdd3",
  null
  
)

export default component.exports